import { consolidatedUserId } from 'common/PresenceAvatars/consolidatedUserId'
import { uniq } from 'lodash'
import { computed, makeAutoObservable, observable, set, get, values, keys, ObservableMap, toJS } from 'mobx'
import { createContext } from 'react'
import { PresenceUser, UsersMetadata, ElementPresence } from 'types'

export const DocPresenceContext = createContext<DocPresence | null>(null)

export class DocPresence {
  usersByLayer: ObservableMap<string, PresenceUser[]> = observable.map()
  followedUser: {
    meta: UsersMetadata[string] | null
    user: PresenceUser
  } = { user: null, meta: null }
  followedBy: PresenceUser[] = []

  constructor() {
    makeAutoObservable(this, {
      usersOnDoc: computed.struct,
    })
  }

  get usersOnDoc() {
    return uniq(values(this.usersByLayer).flat()).slice()
  }

  upsertObserver = (user: PresenceUser) => {
    if (!this.followedBy.some((follower) => consolidatedUserId(follower) === consolidatedUserId(user))) {
      this.followedBy = [...this.followedBy, user]
    }
  }

  removeStaleObservers = () => {
    const idsToRemove: number[] = []

    for (const user of this.followedBy) {
      if (!this.usersOnDoc.some((u) => consolidatedUserId(u) === consolidatedUserId(user))) {
        idsToRemove.push(consolidatedUserId(user))
      }
    }

    this.followedBy = this.followedBy.filter((follower) => !idsToRemove.includes(consolidatedUserId(follower)))
    if (
      this.followedUser.user &&
      !this.usersOnDoc.some((u) => consolidatedUserId(u) === consolidatedUserId(this.followedUser.user))
    ) {
      this.followedUser = { user: null, meta: null }
    }
  }

  removeObserver = (userId: number) => {
    this.followedBy = this.followedBy.filter((follower) => consolidatedUserId(follower) !== userId)
  }

  updatePresences = (presences: ElementPresence[], layerId: string) => {
    const incomingUsers = presences.map((p) => p.user || p.anonymous_user)

    // remove users present on current layer (layerId) from all layers
    keys(this.usersByLayer).forEach((key) => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const oldUsers = toJS(get(this.usersByLayer, key))!
      const newUsers = oldUsers.filter((u) => {
        return !incomingUsers.map((u) => consolidatedUserId(u)).includes(consolidatedUserId(u))
      })
      set(this.usersByLayer, key, newUsers)
    })

    // add users from presences to current layer (layerId)
    set(this.usersByLayer, layerId, incomingUsers)

    this.removeStaleObservers()
  }
}
